<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('标题')" prop="title">
                <a-input v-model="queryParam.title" :maxLength="32" :placeholder="$t('请输入')+$t('标题')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('作者名称')" prop="authorName">
                <a-input v-model="queryParam.authorName" :maxLength="32" :placeholder="$t('请输入')+$t('作者名称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.postTableRef.openDrawer()" v-hasPermi="['discovery:discoverhotpostconf:add']">
          <a-icon type="plus" />
          {{ $t('选择帖子') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['discover:discoverhotpostconf:remove']">
          <a-icon type="delete" />
          {{ $t('删除') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <template slot="contentType" slot-scope="text, record">
          <span v-if="record.contentType === 1">{{$t('图文')}}</span>
          <span v-else-if="record.contentType === 2">{{$t('视频')}}</span>
        </template>
        <template slot="channelList" slot-scope="text, record">
          <span v-if="record.channelList && record.channelList.length > 0">{{ record.channelList.join('、') }}</span>
        </template>
        <template slot="topicList" slot-scope="text, record">
          <span v-if="record.topicList && record.topicList.length > 0">{{ record.topicList.join('、') }}</span>
        </template>
        <template slot="mediaUrls" slot-scope="text, record">
          <div style="width:40px;height:40px;">
            <img
              v-if="record.contentType === 1 && record.mediaUrls && record.mediaUrls.length > 0"
              :src="record.mediaUrls[0]"
              style="width:40px;height:40px;"
              @click="handleRecordPreview(record.mediaUrls[0])"
              alt="none"
            />
          </div>
        </template>
        <template slot="isRecommend" slot-scope="text, record">
          <a-switch :checked="record.isRecommend" disabled></a-switch>
          {{ !record.isRecommend ? '关闭' : '开启' }}
        </template>
        <template slot="shelfStatus" slot-scope="text, record">
          <a-switch :checked="record.shelfStatus === 1" disabled></a-switch>
          {{ record.shelfStatus === 1 ? '上架' : '下架' }}
        </template>
        <template slot="postStatus" slot-scope="text, record">
          <span v-if="record.postStatus === 0">     {{$t('草稿箱')}} </span>
          <span v-else-if="record.postStatus === 1">{{$t('审核中')}} </span>
          <span v-else-if="record.postStatus === 2">{{$t('人工审核')}}</span>
          <span v-else-if="record.postStatus === 3">{{$t('机审拒绝')}}</span>
          <span v-else-if="record.postStatus === 4">{{$t('人审拒绝')}}</span>
          <span v-else-if="record.postStatus === 5">{{$t('举报下架')}}</span>
          <span v-else-if="record.postStatus === 6">{{$t('发布成功')}}</span>
          <span v-else-if="record.postStatus === 7">{{$t('主动下架')}}</span>
        </template>
        <span slot="publishTime" slot-scope="text, record">
          {{ parseTime(record.publishTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <template slot="sort" slot-scope="text, record">
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <a-input v-model="record.sort" style="width: 60%px; margin-right: 4px;" />
            <a @click="handleChangeSort(record)">确认</a>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['discover:discoverhotpostconf:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <discovery-post-select-table ref="postTableRef" @onSubmit="handleSelected" />
  </page-header-wrapper>
</template>

<script>
import { pageDiscoverHotPostConf, listDiscoverHotPostConf, delDiscoverHotPostConf, batchAddDiscoverHotPostConf, changeSortDiscoverHotPostConf } from '@/api/discover/discoverHotPostConf'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import DiscoveryPostSelectTable from '@/views/discovery/discoveryPost/modules/DiscoveryPostSelectTable.vue'

export default {
  name: 'DiscoverHotPostConf',
  components: {
    DiscoveryPostSelectTable,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        postId: undefined,
        sort: undefined,
        isEnabled: undefined,
        publishTime: undefined,
        title: undefined,
        authorName: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('标题'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('作者'),
          dataIndex: 'authorName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('类型'),
          dataIndex: 'contentType',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'contentType' }
        },
        {
          title: this.$t('封面图'),
          dataIndex: 'mediaUrls',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'mediaUrls' }
        },
        {
          title: this.$t('频道'),
          dataIndex: 'channelList',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'channelList' }
        },
        {
          title: this.$t('话题'),
          dataIndex: 'topicList',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'topicList' }
        },
        {
          title: this.$t('排序'),
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'sort' }
        },
        {
          title: this.$t('浏览量'),
          dataIndex: 'viewCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('评论量'),
          dataIndex: 'commentCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('点赞量'),
          dataIndex: 'likeCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('收藏量'),
          dataIndex: 'collectCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title:  this.$t('发布时间'),
          dataIndex: 'publishTime',
          scopedSlots: { customRender: 'publishTime' },
          ellipsis: true,
          align: 'center',
          width: '180px'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '180px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询发现-热搜帖子人工配置列表 */
    getList() {
      this.loading = true
      pageDiscoverHotPostConf(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        postId: undefined,
        sort: undefined,
        isEnabled: undefined,
        publishTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delDiscoverHotPostConf(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('discover/discover/hot/post/conf/export',
            that.queryParam
            , `发现-热搜帖子人工配置_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleSelected(ids) {
      const data = []
      ids.map(id => data.push({ 'id': id }))
      batchAddDiscoverHotPostConf(data)
        .then(() => {
          this.onSelectChange([], [])
          this.getList()
          const message = this.$t('添加成功')
          this.$message.success(
            message,
            3
          )
        })
    },
    handleChangeSort(row) {
      const id = row.id
      const sort = row.sort
      changeSortDiscoverHotPostConf({ id: id, sort: sort })
        .then(() => {
          this.onSelectChange([], [])
          this.getList()
          const message = this.$t('修改成功')
          this.$message.success(
            message,
            3
          )
        })
    }
  }
}
</script>
